export const getters = {
  getModalViewCareer: state => state.modalViewCareer,
  getCareers: state => state.careers,
  getCareer: state => state.career
};

export default {};
